import { AxiosProgressEvent, AxiosResponse } from 'axios';
import { useState } from 'react';
import { AxiosMediaUploadInstance } from '@/lib/axios/axios';

type RequestBody = FormData | { [key: string]: string | number | boolean };

export function useMedia<TResponse extends object>(url: string) {
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  async function uploadMedia(body: RequestBody): Promise<TResponse> {
    setLoading(true);
    setUploadProgress(0);

    try {
      const response: AxiosResponse<TResponse> = await AxiosMediaUploadInstance.post(url, body, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
          const percentCompleted = Math.round((progressEvent.progress ?? 0) * 100);
          setUploadProgress(percentCompleted);
        },
      });

      return response.data;
    } finally {
      setLoading(false);
    }
  }

  const reset = () => {
    setUploadProgress(0);
  };

  return {
    uploadMedia,
    loading,
    uploadProgress,
    reset,
  };
}
